import React from 'react';
import UserNavbar from './layout/user-navbar';

let crossImg = require('../../img/ic-x.svg');

const ConnectStripeFail= () =>
(
    <div className="cover connect-stripef-pg">
        <UserNavbar />
        <div className="container">

            <div className="row">
                <div className="col-md-12">

                    <img className = "center-block img-responsive"
                        src        = {crossImg}
                        alt        = "Stripe connection failed"/>

                    <h1 className="text-center">
                        We were unable to connect to your Stripe account.
                    </h1>

                    <p>
                        Please contact our Support to resolve this issue:
                    </p>
                    <div>
                        <table class="table">
                            <tbody>
                                <tr>
                                    <td>
                                        <p>
                                            <i className="material-icons">email</i>
                                            <a href="#">
                                                support@freshbytes.io
                                            </a>
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p>
                                            <i className="material-icons">call</i>
                                            (310) 461-4132
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <br/>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

export default ConnectStripeFail;



// WEBPACK FOOTER //
// src/components/connect-stripe-fail.js